type LogLevel = "debug" | "info" | "warn" | "error";

const isDev =
  typeof process !== "undefined"
    ? process.env.NODE_ENV === "development"
    : false;

const isDebugForced = () => {
  try {
    return (
      typeof window !== "undefined" &&
      (window.localStorage.getItem("gt_debug") === "1" ||
        window.localStorage.getItem("gt_debug") === "true")
    );
  } catch {
    return false;
  }
};

const shouldLog = (level: LogLevel): boolean => {
  if (level === "error") return true;
  if (level === "warn") return true;
  if (isDev || isDebugForced()) return true;
  return false;
};

const noop = (..._args: unknown[]) => {};

const createTaggedLogger = (tag: string) => {
  const prefix = `[${tag}]`;
  return {
    debug: (...args: unknown[]) =>
      shouldLog("debug") ? console.debug(prefix, ...args) : noop(),
    info: (...args: unknown[]) =>
      shouldLog("info") ? console.info(prefix, ...args) : noop(),
    warn: (...args: unknown[]) =>
      shouldLog("warn") ? console.warn(prefix, ...args) : noop(),
    error: (...args: unknown[]) => console.error(prefix, ...args),
  };
};

export const log = {
  map: createTaggedLogger("Map"),
  webgl: createTaggedLogger("WebGL"),
  markers: createTaggedLogger("Markers"),
  geofencing: createTaggedLogger("Geofencing"),
  clustering: createTaggedLogger("Clustering"),
  telemetry: createTaggedLogger("Telemetry"),
  route: createTaggedLogger("Route"),
  markerContent: createTaggedLogger("MarkerContent"),
  polyline: createTaggedLogger("PolylineAnimator"),
  playback: createTaggedLogger("Playback"),
  simulator: createTaggedLogger("Simulator"),
  futuristicMap: createTaggedLogger("FuturisticMap"),
  api: createTaggedLogger("API"),
};
